import { PageTransition } from '../PageTransition';
import { MassMessagesPage } from '../MassMessages/compact/MassMessagesPage';

interface PriorityMassMessagesTabProps {
  accountId: string;
  platform?: 'onlyfans' | 'fansly';
}

/** Priority Mass Messages — the same compact Setup + Schedule as Mass Messages,
 *  with priority campaign flags (keep in DMs) and cancel instead of delete. */
export function PriorityMassMessagesTab({ accountId, platform = 'onlyfans' }: PriorityMassMessagesTabProps) {
  return (
    <PageTransition>
      <MassMessagesPage key={accountId} kind="priority" accountId={accountId} platform={platform} />
    </PageTransition>
  );
}
